import { defineMessages } from 'react-intl';

export default defineMessages({
	clearLabel: {
		defaultMessage: 'Reset search',
		description: 'Label for icon that clears the search term',
		id: 'search.input.clear',
	},
	inputAriaLabel: {
		defaultMessage: 'Question or search terms',
		description: 'ARIA label for textbox that allows asking a question or searching for results',
		id: 'search.input.label.ai',
	},
	inputPlaceholder: {
		defaultMessage: 'Ask a question or search for information',
		description: 'Placeholder message for the new search bar describing what they can look for',
		id: 'search.input.placeholder.ai',
	},
	// eslint-disable-next-line rulesdir/i18n-unique-message-ids
	inputAriaLabelNoAI: {
		defaultMessage: 'Search for information',
		description: 'ARIA label for textbox that allows asking a question or searching for results',
		id: 'search.input.label.no-ai',
	},
	// eslint-disable-next-line rulesdir/i18n-unique-message-ids
	inputPlaceholderNoAI: {
		defaultMessage: 'Search for information',
		description: 'Placeholder message for the new search bar describing what they can look for',
		id: 'search.input.placeholder.no-ai',
	},
	askTheVirtualServiceAgent: {
		defaultMessage: 'Ask the virtual service agent',
		description: 'Hint to the user to initiate the virtual service agent conversation',
		id: 'search.input.placeholder.ai.ask-the-virtual-service-agent',
	},
	search: {
		defaultMessage: 'Search',
		description: 'Hint to the user to press enter to go to search results page',
		id: 'search.input.hint',
	},
	ariaDescription: {
		defaultMessage:
			'Typing letters in the search input updates the search results in below data table',
		description: 'description for screen reader users when they focus on the search bar ',
		id: 'search.input.aria-description',
	},
});
